@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";
@import "/src/variables/breakpoints";
.main {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: block;
  max-height: calc(100dvh - 240px);
  overflow: scroll;
  overflow-x: hidden;
  // margin: 0 -10px;
  // margin-left: -10px;
  @media only screen and (max-width: $breakpoint-mobile-max) {
    max-height: calc(100dvh - 420px);
    overflow: auto;
    margin: 0;
  }
  .listContainer {
    display: flex;
    flex-direction: column;
    gap: $space-10;
  }
  .card {
    height: 100%;
    z-index: $z-index-999;
    // border-radius: 6px;
    // width: 100%;
    background-color: $zv-surface--Primary-BG-Color;
    cursor: pointer;
    // margin-bottom: 10px;
    padding: 0px $space-10;
    box-shadow:
      $blue-28-a25 0px 2px 5px -1px,
      rgba($Neutral-Darkest, 0.3) 0px 1px 3px -1px;
    // min-height: 50px;
    // border: 1px solid green;
    .title {
      font-family: $font-primary;
      line-height: $line-height-ratio-1;
      font-weight: $font-weight-medium;
      font-size: $font-size-h14;
    }
    .detailsCard {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding-top: 5px;
      .dateInfo {
        font-size: $font-size-h10;
        font-family: $font-primary;
        line-height: $line-height-ratio-1;
        font-weight: $font-weight-medium;
      }
      .createdOn {
        font-size: $font-size-h10;
        font-family: $font-primary;
        line-height: $line-height-ratio-1;
        font-weight: $font-weight-medium;
      }
    }
  }
}
.main::before,
.main::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: block;
}

::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: $zv-well--gray-94-9;
}
::-webkit-scrollbar-thumb {
  background: $zv-border--gray-69;
}
::-webkit-scrollbar-thumb:hover {
  background: $zv-border--gray-69;
}

.loader {
  margin-top: $space-30;
}
